// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selection-group[data-v-5f3fb8ec] {\n  height: 90px;\n}\n.autoscale-label[data-v-5f3fb8ec] label {\n  font-size: 0.75em;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
